import GenresManager from '../../beatport/content/GenresManager';
export default GenresManager;
